import { getWebInstrumentations } from '@grafana/faro-react'
import { faro } from '@grafana/faro-web-sdk'
import { v4 as uuidv4 } from 'uuid'

const { REACT_APP_API_KEY_GRAFANA_FARO } = process.env

const { enabledGrafanaFaro, enabledGrafanaFaroPerformanceInstrumentation } =
  window.fflags || {}
const { grafanaFaroEnvironment, grafanaFaroUrl } = window.def || {}
export const grafanaUtils = {
  getInitialOptions() {
    const initialOptions = {
      apiKey: REACT_APP_API_KEY_GRAFANA_FARO,
      app: {
        environment: grafanaFaroEnvironment,
        name: 'edubook_def',
      },
      batching: {
        enabled: true,
      },
      instrumentations: [
        ...getWebInstrumentations({
          captureConsole: true,
          enablePerformanceInstrumentation:
            enabledGrafanaFaroPerformanceInstrumentation,
        }),
      ],
      session: window.__PRELOADED_STATE__?.faro?.session,
      url: grafanaFaroUrl,
    }
    return initialOptions
  },
  pushEvent(events) {
    if (!enabledGrafanaFaro) {
      return
    }
    faro.api.pushEvent(events)
  },
  setUser({ email, role, userId, username }) {
    if (!enabledGrafanaFaro) {
      return
    }
    const nameItem = 'uuidDevice'
    let uuidDevice = localStorage.getItem(nameItem)
    if (!uuidDevice) {
      uuidDevice = uuidv4()
      localStorage.setItem(nameItem, uuidDevice)
    }
    faro.api.setUser({
      attributes: {
        role,
        username: username ?? email,
        uuidDevice,
      },
      id: userId,
    })
  },
  setView(view) {
    if (!enabledGrafanaFaro) {
      return
    }
    faro.api.setView({ name: view })
  },
}
